import VueRouter from 'vue-router'

const { push, replace } = VueRouter.prototype

const { isNavigationFailure, NavigationFailureType } = VueRouter

VueRouter.prototype.push = function(location) {
  //@ts-ignore
  return push.call(this, location).catch(error => {
    if (!isNavigationFailure(error, NavigationFailureType.duplicated)) {
      throw Error(error)
    }
  })
}
VueRouter.prototype.replace = function(location) {
  //@ts-ignore
  return replace.call(this, location).catch(error => {
    if (!isNavigationFailure(error, NavigationFailureType.duplicated)) {
      throw Error(error)
    }
  })
}
export * from 'vue-router'
export default VueRouter
